function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, Object, String, currentTab, isLoading, orgs, overSeatCount, selectedOrg, userFile, userRows) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['invite-users-row'] = function(row, idx) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'invite-users-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'invite-users-column': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((!idx) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'invite-users-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Email Address");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'invite-users-input-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("input", {
                "attrs": {
                  type: `text`,
                  /* autocomplete=off does not work as of Chrome 34 */
                  autocomplete: `invite-users-autocomplete-off`,
                },
                "props": {
                  value: row.email,
                },
                "on": {
                  input: ev => $helpers.updateUserEmail(ev, row),
                  focus: $helpers.clearErrors,
                  blur: ev => $helpers.updateEmailError(ev, row),
                },
                "class": {
                  'invite-users-input': true,
                  'invite-users-email-input': true
                },
              }));
              __jade_nodes = __jade_nodes.concat(((row.emailError || row.emailInfo) && row === userRows.find(userRow => userRow.email === row.email)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                  "attrs": {
                    'always-show': true,
                    'type': row.emailInfo ? `default` : `error`,
                    'placement': `left`,
                  },
                }, (function() {
                  var __jade_nodes = [];
                  const descriptor = row.email && row.email.length ? `a valid` : `an`;;
                  __jade_nodes = __jade_nodes.concat(row.emailErrorMsg || `Please enter ${descriptor} email address`);;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'invite-users-column': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((!idx) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'invite-users-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Organization Role");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'invite-users-input-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-select", {
                "attrs": {
                  'selected-option': row.orgRole ? $helpers.capitalize(row.orgRole) : `Select role`,
                  'menu-height': 350,
                  /* menu with 4 roles is just over 200px, looks weird */
                },
                "props": {
                  sections: $helpers.getOrgRoleSections(),
                },
                "on": {
                  change: ev => $helpers.selectOrgRole(ev, row),
                  focus: $helpers.clearErrors,
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat((row.orgRoleError && row === userRows.find(row => row.orgRoleError)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                "attrs": {
                  'always-show': true,
                  'type': `error`,
                  'placement': `top`,
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Please select a role");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((currentTab === $helpers.TABS.PROJECT) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'invite-users-column': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((!idx) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'invite-users-title': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Projects");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              const numProjects = row.projectIds.length;;
              const projectPlural = $helpers.pluralize(`project`, numProjects);;
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'invite-users-input-container': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-select", {
                  "attrs": {
                    'selected-option': numProjects ? `${numProjects} ${projectPlural}` : `Select projects`,
                    'multiple': true,
                    'show-select-all': true,
                  },
                  "props": {
                    sections: $helpers.getProjectSections(row),
                  },
                  "on": {
                    change: ev => $helpers.toggleProjectSelected(ev, row),
                    selectAll: ev => $helpers.toggleAllProjectsSelected(ev, row),
                    focus: $helpers.clearErrors,
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat((row.projectError && row === userRows.find(row => row.projectError)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                  "attrs": {
                    'always-show': true,
                    'type': `error`,
                    'placement': `top`,
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Please select at least one project");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'invite-users-column': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((!idx) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'invite-users-title': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Project Role");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'invite-users-input-container': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-select", {
                  "attrs": {
                    'selected-option': row.projectRole ? $helpers.capitalize(row.projectRole) : `Select role`,
                    'menu-height': 300,
                    /* menu with 4 roles is just over 200px, looks weird */
                  },
                  "props": {
                    sections: $helpers.getProjectRoleSections(),
                  },
                  "on": {
                    change: ev => $helpers.selectProjectRole(ev, row),
                    focus: $helpers.clearErrors,
                  },
                }));
                __jade_nodes = __jade_nodes.concat((row.projectRoleError && row === userRows.find(row => row.projectRoleError)) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                    "attrs": {
                      'always-show': true,
                      'type': `error`,
                      'placement': `right`,
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Please select a role");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((currentTab === $helpers.TABS.TEAM) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'invite-users-column': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((!idx) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'invite-users-title': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Teams");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              const numTeams = row.teamNames.length;;
              const teamPlural = $helpers.pluralize(`team`, numTeams);;
              __jade_nodes = __jade_nodes.concat(h("mp-select", {
                "attrs": {
                  'selected-option': numTeams ? `${numTeams} ${teamPlural}` : `Select teams`,
                  'multiple': true,
                  'show-select-all': true,
                },
                "props": {
                  sections: $helpers.getTeamSections(row),
                },
                "on": {
                  change: ev => $helpers.toggleTeamSelected(ev, row),
                  selectAll: ev => $helpers.toggleAllTeamsSelected(ev, row),
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((userRows.length > 1) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "on": {
                click: () => $helpers.clickedDeleteButton(row)
              },
              "class": {
                'invite-users-remove-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": {
                  icon: `x`
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat((row.projectIdsToDowngrade.length) ? ((function() {
          var __jade_nodes = [];
          const downgradedProjectsString = $helpers.getDowngradedProjectsString(row);
          const allDowngradedProjectsString = $helpers.getAllDowngradedProjectsString(row);
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'invite-users-row-error': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'invite-users-error-title': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("You do not have permission to assign the Project Role of Owner for all");
              __jade_nodes = __jade_nodes.concat(" the selected projects.");
              __jade_nodes = __jade_nodes.concat(" Admin will be assigned for " + (row.projectIdsToDowngrade.length) + " projects:");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat((row.seeAll) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'projects-list': true
                },
              }, [__vjadeSafeCode(allDowngradedProjectsString)]));;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'project-list': true
                },
              }, [__vjadeSafeCode(downgradedProjectsString)]));
              __jade_nodes = __jade_nodes.concat((downgradedProjectsString.length < allDowngradedProjectsString.length) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "on": {
                    click: () => $helpers.seeAllDowngradedProjects(idx)
                  },
                  "class": {
                    'invite-users-see-all': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("See All");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'settings-screen-modal': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-modal", {
          "attrs": {
            open: $attr(`open`)
          },
          "on": {
            change: $helpers.modalVisibilityChanged
          },
          "class": {
            'invite-users-modal': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-modal-header': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((isLoading) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-spinner", {
                "attrs": {
                  color: `white`
                },
              }));;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Invite New Users");;
              return __jade_nodes
            }).call(this)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-modal-tab-section': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-toggle", {
              "attrs": {
                selected: currentTab,
                theme: `lite`,
                large: false,
                spacing: 20,
              },
              "on": {
                select: $helpers.selectTab,
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-toggle-option", {
                "attrs": {
                  value: $helpers.TABS.PROJECT
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Invite to projects");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-toggle-option", {
                "attrs": {
                  value: $helpers.TABS.TEAM
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Invite to teams");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-toggle-option", {
                "attrs": {
                  value: $helpers.TABS.BULK
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Bulk invite");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((orgs.length > 1) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'invite-users-select-org': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'invite-users-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("organization");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-select", {
                "attrs": {
                  'selected-option': selectedOrg ? selectedOrg.name : `Select organization`,
                },
                "props": {
                  sections: $helpers.getOrgSections(),
                },
                "on": {
                  change: $helpers.selectOrg,
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": Object.assign({}, {
              'invite-users-hidden': !selectedOrg
            }, {
              'invite-users-add-users': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((selectedOrg && $helpers.isOverSeatCount()) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'invite-users-warning-text-container': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                  "attrs": {
                    icon: `warning`
                  },
                }));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'invite-users-warning-text': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("You have run out of seats in your organization!");
                  __jade_nodes = __jade_nodes.concat(` `);
                  __jade_nodes = __jade_nodes.concat(($helpers.hasBillingPerms()) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Click");
                      __jade_nodes = __jade_nodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(" ");;
                        return __jade_nodes
                      }).call(this));
                      __jade_nodes = __jade_nodes.concat("");;
                      return __jade_nodes
                    }).call(this));
                    __jade_nodes = __jade_nodes.concat(h("a", {
                      "attrs": {
                        href: `/pricing`
                      },
                      "on": {
                        click: $helpers.trackUpsellClick
                      },
                      "props": {
                        id: 'pricing-link'
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("here");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat(" to upgrade your plan.");;
                    return __jade_nodes
                  }).call(this)) : ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Contact your organization admin to upgrade your plan.");;
                    return __jade_nodes
                  }).call(this)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat((currentTab === $helpers.TABS.PROJECT || currentTab === $helpers.TABS.TEAM) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((selectedOrg) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((function() {
                  var $$obj = (userRows);
                  var $$eachNodes;
                  var $$iterated = false;
                  if (Array.isArray($$obj)) {
                    $$eachNodes = $$obj.reduce(function($$eachNodes, row, idx) {
                      $$iterated = true;
                      return $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(jade_mixins['invite-users-row'].call(this, row, idx));;
                        return __jade_nodes
                      }).call(this));
                    }, []);
                  } else {
                    $$eachNodes = [];
                    for (var $$objKey in $$obj) {
                      (function() {
                        var idx = $$objKey;
                        if ($$obj.hasOwnProperty(idx)) {
                          $$iterated = true;
                          var row = $$obj[idx];
                          $$eachNodes = $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(jade_mixins['invite-users-row'].call(this, row, idx));;
                            return __jade_nodes
                          }).call(this));
                        }
                      })();
                    }
                  }

                  return $$eachNodes;
                })());;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'invite-users-add-another-user': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "on": {
                    click: $helpers.clickedAddMoreUser
                  },
                  "class": {
                    'invite-users-add-another-user-button': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                    "attrs": {
                      icon: `plus`
                    },
                  }));
                  __jade_nodes = __jade_nodes.concat("Add another user");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'invite-users-add-another-user-alignment': true
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat((currentTab === $helpers.TABS.BULK) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'invite-users-bulk-add-users': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'invite-users-bulk-add-users-title': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("File name");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'invite-users-bulk-add-file-uploader': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-file-uploader", {
                    "attrs": {
                      accept: `text/csv`,
                      placeholder: `Please select a CSV file...`,
                      label: `Select CSV File`,
                    },
                    "on": {
                      change: $helpers.fileStatusChanged
                    },
                  }));
                  __jade_nodes = __jade_nodes.concat((userFile && userFile.error) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                      "attrs": {
                        'always-show': true,
                        'type': `error`,
                        'placement': `bottom`
                      },
                    }, [__vjadeSafeCode(userFile.errorMsg || `Please select a CSV file`)]));;
                    return __jade_nodes
                  }).call(this)) : undefined);;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'invite-users-bulk-add-users-subtitle': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Please follow the format of our");
                  __jade_nodes = __jade_nodes.concat(h("a", {
                    "attrs": {
                      href: `https://cdn.mxpnl.com/static/organizations/bulk_add_template.csv`,
                      download: `bulk_adding_template.csv`,
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("CSV template");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-modal-bottom-buttons': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "attrs": {
                size: `small`,
                disabled: isLoading || !$attr(`open`) || overSeatCount || !selectedOrg
              },
              "on": {
                click: $helpers.clickedSave
              },
              "class": {
                'mp-button-primary': true,
                'mp-modal-button': true
              },
            }, [__vjadeSafeCode(currentTab === $helpers.TABS.BULK ? `Upload` : `Invite`)]));
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "attrs": {
                size: `small`
              },
              "on": {
                click: $helpers.clickedCancel
              },
              "class": {
                'mp-button-secondary': true,
                'mp-modal-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Cancel");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "currentTab" in locals ? locals.currentTab : typeof currentTab !== "undefined" ? currentTab : undefined, "isLoading" in locals ? locals.isLoading : typeof isLoading !== "undefined" ? isLoading : undefined, "orgs" in locals ? locals.orgs : typeof orgs !== "undefined" ? orgs : undefined, "overSeatCount" in locals ? locals.overSeatCount : typeof overSeatCount !== "undefined" ? overSeatCount : undefined, "selectedOrg" in locals ? locals.selectedOrg : typeof selectedOrg !== "undefined" ? selectedOrg : undefined, "userFile" in locals ? locals.userFile : typeof userFile !== "undefined" ? userFile : undefined, "userRows" in locals ? locals.userRows : typeof userRows !== "undefined" ? userRows : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;